import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import { createSelector } from "reselect";
import {
  determineScopeFromPath,
  TEMP_SCOPE,
} from "../../components/Header/HeaderPrimary/NavigationTabs/constants";

import {
  PERSONAL_LISTS,
  TEAM_LISTS,
} from "../../components/employer/Agencies/constants";
import { individualsSelector } from "../individualSelectors";

import { getAllLegacyInvitations, getPreferredLinks } from "./agencySelectors";

export const getAllRecruiterLists = (state) => state.recruiterLists.items;
export const getRecruiterListById = (state, props) =>
  state.recruiterLists.items[props.recruiterListId].attributes;
export const getRecruiterListsLoadStatus = (state) =>
  state.recruiterLists.loaded;

export const makeGetRecruiterListById = () =>
  createSelector(
    [getAllRecruiterLists, (_, listId) => listId],
    (recruiterLists, listId) => recruiterLists[listId]
  );

const getPathname = () =>
  typeof window !== "undefined" ? window.location.pathname : "";

export const makeGetRecruiterLists = (listScope) =>
  createSelector(
    [getAllRecruiterLists, getPathname],
    (recruiterLists, pathname) => {
      const scope = determineScopeFromPath(pathname);
      const moduleType = scope === TEMP_SCOPE ? "contingent" : "perm";

      const listsForModule = filter(
        recruiterLists,
        ({ attributes }) => attributes.moduleType === moduleType
      );

      switch (listScope) {
        case PERSONAL_LISTS:
          return filter(
            listsForModule,
            ({ attributes }) => attributes.ownerType === "Individual"
          );
        case TEAM_LISTS:
          return filter(
            listsForModule,
            ({ attributes }) => attributes.ownerType === "Organization"
          );
        default:
          return listsForModule || [];
      }
    }
  );

export const makeGetRecruiterListIndividuals = () =>
  createSelector(
    [
      getPreferredLinks,
      getAllRecruiterLists,
      individualsSelector,
      getAllLegacyInvitations,
      (_, listId) => listId,
    ],
    (preferredLinks, recruiterLists, individuals, invitations, listId) => {
      if (isEmpty(recruiterLists[listId])) return [];
      const preferredLinkOrganizationIds = map(
        preferredLinks,
        ({ attributes }) => attributes.recruiterOrganizationId
      );

      const recruitersWithPrefLink = filter(
        individuals,
        ({ id, attributes }) =>
          includes(recruiterLists[listId].attributes.subjectIds, id) &&
          includes(preferredLinkOrganizationIds, attributes.organizationId)
      );

      const legacyInvites = filter(invitations, ({ id }) =>
        includes(recruiterLists[listId].attributes.subjectIds, id)
      );

      return recruitersWithPrefLink.concat(legacyInvites);
    }
  );
